
$(() => {
    Promise.all([
        Data.init(),
        Urls.init(),
        Localisation.init(),
    ]).then(()=>{
        Home.init();
        Visualisation.init();
        Ui.init();
    })

    // Show breakpoint debug on localhost
    if (window.location.host.match(/localhost|nikko.local|duderino.local/i)) {
        $('#mq').css({display: 'block'});
    }
});

